export const createScoresheetCommentsRequests = (client) => ({
    listScoresheetComments: async (params) => {
        const { data, meta, links } = await client.api.get("scoresheet_comments", {
            params: params,
        });
        return { data, meta, links };
    },
    createScoresheetComment: async (payload) => {
        const { data } = await client.api.create("scoresheet_comments", payload);
        return { data };
    },
});
//# sourceMappingURL=index.js.map